import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsToBeTakenToFedExDto, NeedsToBeTakenToFedExQueryParams } from 'dtos/toDoLists/ohioBuildABoxes'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/ohio-build-a-boxes/needs-to-be-taken-to-fedex`

export const getNeedsToBeTakenToFedExToDoList = (queryParams: NeedsToBeTakenToFedExQueryParams) =>
  apiClient.get<ApiResponse<NeedsToBeTakenToFedExDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
